import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortAlphabetically',
  standalone: false,
})
export class SortAlphabeticallyPipe implements PipeTransform {
  transform(value: Array<any>, params: { param: string; type: string }): any[] {
    if (!params.param && !params.type) {
      return value;
    }
    if (params.param === 'teamName') {
      return value.sort((a, b) => {
        const x =
          typeof a.team?.name === 'string'
            ? a.team?.name.toLowerCase()
            : a.team?.name;
        const y =
          typeof b.team?.name === 'string'
            ? b.team?.name.toLowerCase()
            : b.team?.name;
        if (params.type === 'asc') {
          return x.localeCompare(y);
        } else if (params.type === 'desc') {
          return y.localeCompare(x);
        }
      });
    } else if (params.param === 'name') {
      return value.sort((a, b) => {
        let x = null;
        let y = null;
        if (a?.user) {
          x =
            typeof a.user.name === 'string'
              ? a.user.name.toLowerCase()
              : a.user.name;
          y =
            typeof b.user.name === 'string'
              ? b.user.name.toLowerCase()
              : b.user.name;
        } else {
          x = typeof a.name === 'string' ? a.name.toLowerCase() : a.name;
          y = typeof b.name === 'string' ? b.name.toLowerCase() : b.name;
        }

        if (params.type === 'asc') {
          return x.localeCompare(y);
        } else if (params.type === 'desc') {
          return y.localeCompare(x);
        }
      });
    } else {
      return value.sort((a, b) => {
        const x =
          typeof a[params.param] === 'string'
            ? a[params.param].toLowerCase()
            : a[params.param];
        const y =
          typeof b[params.param] === 'string'
            ? b[params.param].toLowerCase()
            : b[params.param];
        if (params.type === 'asc') {
          return Math.sign(x - y);
        } else if (params.type === 'desc') {
          return -Math.sign(x - y);
        }
      });
    }
  }
}
